import React from 'react'
import './Title.css'
export default function Title({classname,heading,id}) {
  return (
    <h2 id={id} className={`title ${classname ? classname : ""}`}>{heading}</h2>
  )
}
